export enum CacheLength {
	NO_CACHE = 0,
	SHORT = 600,
	LONG = 3600,
}
